import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay} from 'swiper';
export default function () {
    let left_slide_number = document.querySelector('.single-project__left-slider-wrapper').dataset.startSlideLeft;
    let right_slide_number = document.querySelector('.single-project__right-slider-wrapper').dataset.startSlideRight;

    const leftSwiper = new Swiper('.single-project__left-slider', {
        modules: [Navigation, Pagination, Autoplay],
        // slidesPerView: 1,
        spaceBetween: 20,
        resizeObserver: true,
        effect: "slide",
        speed: 2,
        initialSlide: (left_slide_number - 1),
        loop: true,
        navigation: {
            nextEl: ".single-project__left-slider-next",
            prevEl: ".single-project__left-slider-prev",
        },
        pagination: {
            el: ".single-project__left-slider-pagination",
            type: "fraction",
        },
        on: {
            tap: function () {
                leftSwiper.slideNext();
            },
        },
    });

    const rightSwiper = new Swiper('.single-project__right-slider', {
        modules: [Navigation, Pagination, Autoplay],
        // slidesPerView: 1,
        spaceBetween: 20,
        resizeObserver: true,
        effect: "slide",
        speed: 2,
        initialSlide: (right_slide_number - 1),
        loop: true,
        navigation: {
            nextEl: ".single-project__right-slider-next",
            prevEl: ".single-project__right-slider-prev",
        },
        pagination: {
            el: ".single-project__right-slider-pagination",
            type: "fraction",
        },
        on: {
            tap: function () {
                rightSwiper.slideNext();
            },
        },
    });

    function updateSwiperParams(swiper, isMobile) {
        swiper.params.effect = isMobile ? "slide" : "fade";
        swiper.params.speed = isMobile ? 300 : 0;
        swiper.update();
    }

    function handleResize() {
        let windowWidth = document.documentElement.clientWidth;
        let isMobile = true;

        if (windowWidth >= 992) {
            isMobile = false;
        }
        // updateSwiperParams(leftSwiper, isMobile);
        // updateSwiperParams(rightSwiper, isMobile);
    }


    window.addEventListener('resize', handleResize);
    window.addEventListener('load', handleResize);


    handleResize();

}